import { KnowledgeBase } from './knowledge-base.model';

const getSuggestedResults = (state: KnowledgeBase) => state.suggestedResults;
const getSearchResults = (state: KnowledgeBase) => state.searchResults;

export const KnowledgeBaseSelector = {
  getSearchResults,
  getSuggestedResults,
};
